import { parseCityState } from '@shared/parseCityState';


type ParserFn = (args: { value: string; config?: Record<string, any> }) => string;

const parsers: Record<string, ParserFn> = {
  parseCity: ({ value, config: _config }: { value: string; config?: Record<string, any> }): string => {
    const address = parseCityState(value);
    return address?.city || '';
  },

  parseState: ({ value, config: _config }: { value: string; config?: Record<string, any> }): string => {
    const address = parseCityState(value);
    return address?.state || '';
  },

  parseCityState: ({ value, config: _config }: { value: string; config?: Record<string, any> }): string => {
    const city = parsers.parseCity({ value, config: _config });
    const state = parsers.parseState({ value, config: _config });
    return `${city}, ${state}`;
  },

  valueMap: ({ value, config }: { value: string; config?: Record<string, any> }): string => {
    if (!config || typeof config !== 'object') {
      return value;
    }
    return config[value] ?? value;
  },
};

export const FormFieldParser = {
  parsers,
  
  parse: (question: PolicyFormQuestion, value: string): string => {
    if (!question.parser || !question.parser.type) {
      return value;
    }

    const parserFn = parsers[question.parser.type];
    if (!parserFn) {
      return value;
    }

    return parserFn({ value, config: question.parser.config });
  },
};
